<template>
  <div class="switch" v-if="this.isKakoList === '0'">
    <div
      v-bind:class="{
        active1: isSelect === optionOpen || isSelect === undefined
      }"
      @click="changeList(optionOpen)"
      class="button1"
    >
      {{ this.isNow }}<br />キャンペーン
    </div>
    <div
      v-bind:class="{ active1: isSelect === optionPrefectures }"
      @click="changeList(optionPrefectures)"
      class="button1"
    >
      都府県別<br />コレクション
    </div>
  </div>
  <div class="switch" v-else>
    <div
      v-bind:class="{
        active2: isSelect === optionOpen || isSelect === undefined
      }"
      @click="changeList(optionOpen)"
      class="button2"
    >
      {{ this.isNow }}<br />キャンペーン
    </div>
    <div
      v-bind:class="{ active2: isSelect === optionHistory }"
      @click="changeList(optionHistory)"
      class="button2"
    >
      過去の<br />キャンペーン
    </div>
    <div
      v-bind:class="{ active2: isSelect === optionPrefectures }"
      @click="changeList(optionPrefectures)"
      class="button2"
    >
      都府県別<br />コレクション
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'
import moment from 'moment'

export default {
  name: 'SealTopMenu',
  props: {
    select: { type: String }
  },
  data: function () {
    return {
      optionOpen: '開催中のキャンペーン',
      optionPrefectures: '都道府県別コレクション',
      optionHistory: '過去のキャンペーン',
      isSelect: '開催中のキャンペーン',
      isNow: '開催中の',
      isKakoList: '0',
      end_at: ''
    }
  },
  created() {
    this.isSelect = this.select
    const local = localStorage.getItem('isKakoList')
    if (local === '0') {
      this.isKakoList = '0'
    } else {
      this.isKakoList = '1'
    }
    console.log('-- isKakoList:' + this.isKakoList)
    const endAt = localStorage.getItem('isEndAt')
    this.end_at = endAt
    if (this.getExpiredAfter(this.end_at) === false) {
      if (this.isSelect !== '過去のキャンペーン') {
        this.optionOpen = '直近のキャンペーン'
        this.isSelect = '直近のキャンペーン'
        this.isNow = '直近の'
      }
    }
  },
  methods: {
    moment,
    changeList: function (isSelect) {
      this.isSelect = isSelect
      this.$emit('click', isSelect)
    },
    getExpiredAfter(str) {
      const array = str.split('.')
      const dateAt = new Date(array[0])
      const today = new Date()
      if (dateAt.getTime() > today.getTime()) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.switch {
  width: 100%;
  position: absolute;
  bottom: 0%;
  display: flex;
}

.switch .button1 {
  display: flex;
  margin-left: 9px;
  justify-content: center;
  align-items: center;
  height: 12vw;
  flex-basis: 45%;
  flex-shrink: 0;
  border-left: 1px solid #fddc78;
  border-right: 1px solid #fddc78;
  border-top: 1px solid #fddc78;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  font-size: 3.25vw;
  text-align: center;
  background-color: #fddc78;
  color: #5a2200;
}

.switch .active1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 12vw;
  flex-basis: 45%;
  flex-shrink: 0;
  border-left: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
  border-top: 1px solid #ffffff;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  font-size: 3.25vw;
  text-align: center;
  background-color: #ffffff;
  color: #5a2200;
}

.switch .button2 {
  display: flex;
  margin-left: 9px;
  justify-content: center;
  align-items: center;
  height: 12vw;
  flex-basis: 30%; //3は30%
  flex-shrink: 0;
  border-left: 1px solid #fddc78;
  border-right: 1px solid #fddc78;
  border-top: 1px solid #fddc78;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  font-size: 3.25vw;
  text-align: center;
  background-color: #fddc78;
  color: #5a2200;
}

.switch .active2 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 12vw;
  flex-basis: 30%; //3は30%
  flex-shrink: 0;
  border-left: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
  border-top: 1px solid #ffffff;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  font-size: 3.25vw;
  text-align: center;
  background-color: #ffffff;
  color: #5a2200;
}
</style>
